const CaseSharing2 = () => {
  return (
    <>CaseSharing</>
  )
}
export default CaseSharing2
